/** Angular */
import { Injectable } from '@angular/core';
/** Rxjs */
import { Observable } from 'rxjs';
/** Services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
import { BydGenerateParams, BydModel } from '@sixense/byd-core-service';
/** Interfaces */
import { DsFormWordModelInterface } from '../interfaces/form-word-model/ds-form-word-model.interface';
/** Classes */
import { DsFormWordModel } from '../models/ds-form-word-model';
/** Constants */
import { DS_FORMS_BASE_URL } from '../constants/ds-forms-base-url.constant';
import { TemplateTypeEnum } from '../enums/template-type.enum';

@Injectable({
  providedIn: 'root',
})
export class DsFormReportModelsService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get the list of models for a given form template.
   *
   * @param projectId Selected project id
   * @param formTemplateId Form template id
   * @param doctype Template type.
   * @returns Observable<BydModel<DsFormWordModel>>
   */
  public getReportModels(
    projectId: number,
    formTemplateId: number,
    doctype?: TemplateTypeEnum
  ): Observable<BydModel<DsFormWordModel>> {
    this.path = `${DS_FORMS_BASE_URL}${projectId}/forms/${formTemplateId}/customtemplate`;
    const params = BydGenerateParams({ doctype });
    return this.getModels<DsFormWordModel>({ params });
  }

  /**
   * Imports a model for the form template and returns the created id.
   *
   * @param projectId Selected project id
   * @param formTemplateId Form template id
   * @param file Word File
   * @returns Observable<number>
   */
  public importReportModel(projectId: number, formTemplateId: number, file: File): Observable<number> {
    this.path = `${DS_FORMS_BASE_URL}${projectId}/forms/${formTemplateId}/customtemplate`;
    const body = new FormData();
    body.append('file', file);
    const headers = this.bydConfigService.headers.delete('Content-Type');
    return this.post<number>({ body, headers });
  }

  /**
   * Deletes the selected model.
   *
   * @param projectId Selected project id
   * @param formTemplateId Form template id
   * @param reportModelId model id
   * @returns Observable<boolean>
   */
  public deleteReportModel(projectId: number, formTemplateId: number, reportModelId: number): Observable<boolean> {
    this.path = `${DS_FORMS_BASE_URL}${projectId}/forms/${formTemplateId}/customtemplate/${reportModelId}`;
    return this.delete<boolean>();
  }

  /**
   * Create DsFormWordModel instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsFormWordModel` instance.
   */
  public createNewInstance(jsonObject: DsFormWordModelInterface) {
    return new DsFormWordModel(jsonObject);
  }
}
